import { useEffect } from "react";

/** `(3) ` ya da `(99+) ` — başka bir yerden kalmış önek de dahil, tek biçim. */
const PREFIX = /^\(\d+\+?\)\s/;

/** Sekme şeridinde okunacak en uzun sayı. Üç haneli bir sayı başlığın kendisini iter. */
const TITLE_CAP = 99;

function withoutPrefix(title: string): string {
  return title.replace(PREFIX, "");
}

/**
 * Okunmamış sohbet toplamı SEKME BAŞLIĞINDA: `(3) ALTEK ERP`.
 *
 * Başka bir sekmede çalışan kişi köşedeki sohbet düğmesini görmüyor; tarayıcının sekme
 * şeridinde gördüğü tek şey başlık. Yeni mesajın arkadaki sekmede okunmuş sayılmaması
 * (`usePageAttention`) bu yüzden başlıkla birlikte geliyor: okunmamış kalan mesaj bir yerde
 * görünmeli.
 *
 * BAŞLIĞIN SAHİBİ BU KANCA DEĞİL. Uygulama başlığı bugün `index.html`'den geliyor, ama bir
 * ekran onu değiştirirse önek o başlığın ÜSTÜNE yazılıyor: her yazımda var olan önek sökülüp
 * yenisi takılıyor, yani iki önek üst üste binmiyor. Kanca ayrılınca önek kalkıyor.
 *
 * Sayı `total` — sessize alınan konuşmalar dahil. Sunucunun `unread-count` toplamı bugün onları
 * ayırmıyor (denetim Sohbet 11, arka uç işi); ayrılınca bu kanca değişmeden doğru sayıyı gösterir.
 */
export function useUnreadDocumentTitle(count: number): void {
  useEffect(() => {
    const base = withoutPrefix(document.title);
    if (count <= 0) {
      document.title = base;
      return;
    }
    const label = count > TITLE_CAP ? `${String(TITLE_CAP)}+` : String(count);
    document.title = `(${label}) ${base}`;
  }, [count]);

  useEffect(
    () => () => {
      document.title = withoutPrefix(document.title);
    },
    [],
  );
}
